/* eslint-disable prettier/prettier */
/*jshint esversion: 6 */

import axios from "axios";

export const loadcockpit = {
  components: {},
  props: { lang: String, region: String },
  data() {
    return {
      interface: null,
    };
  },
  methods: {
    t: function(value) {
      try {
        if (value in this.interface[this.lang]) {
          return this.interface[this.lang][value];
        } else {
          return value;
        }
      } catch (e) {
        return value;
      }
    },
  },
  created() {
    try {
      if (this.region == "VL") {
        this.regio = "Vlaanderen";
      } else if (this.region == "WA") {
        this.regio = "Wallonië";
      } else if (this.region == "BXL") {
        this.regio = "Brussel";
      }
    } catch (e) {
      this.lang = "nl";
      this.region = "VL";
    }
    if (this.lang == "") {
      this.lang = "nl";
    }
    axios
      .get(
        "https://parentia.rubico.be/cockpit/api/lokalize/project/CB_Interface?token=account-e3a92457d6330430ec16e25fde9f42",
      )
      .then(response => {
        this.interface = response.data;
      });
  },
};
